import { triggerEvent, raiseWarning } from '../../../fc-core/src/event-api';
import { sourceName, onDataLoadRequest, onDataLoadRequestCancel } from '../utils/url-transcoder-utils';
var BASE_FORMAT = 'xml';
var UNDEF;

function fetchXML() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var c = arguments.length > 2 ? arguments[2] : undefined;
  var d = arguments.length > 3 ? arguments[3] : undefined;
  var e = arguments.length > 4 ? arguments[4] : undefined;
  triggerEvent('dataLoadRequested', e, {
    source: sourceName,
    url: a,
    dataFormat: BASE_FORMAT,
    silent: !!d,
    config: b,
    successcallback: c
  }, UNDEF, onDataLoadRequest, onDataLoadRequestCancel);
}

function setXMLUrl(a) {
  this.setChartDataUrl(a, 'xmlurl');
}

function setDataURL() {
  raiseWarning(this, '11171116293', 'run', 'JavaScriptRenderer~setDataURL()', 'Use of deprecated "setDataURL()". Replace with "setXMLUrl()".'), this.setXMLUrl.apply(this, arguments);
}

function wrapper(a) {
  return a && (a.prototype.setXMLUrl = setXMLUrl), a && (a.prototype.setDataURL = setDataURL), {
    format: 'xmlurl',
    toJSON: fetchXML
  };
}

export default {
  extension: wrapper,
  name: 'XMLUrl',
  type: 'transcoder',
  requiresFusionCharts: !0
};